import { cn } from '@/helpers/classnames';
import { useIntl } from 'react-intl';

interface NotificationDotProps {
  count?: number;
  className?: string;
  label?: string;
}

export const NotificationDot = ({
  count,
  className,
  label,
}: NotificationDotProps) => {
  const { formatMessage } = useIntl();

  const ariaLabel =
    label ??
    (count
      ? formatMessage({ defaultMessage: '{count} notifieringar' }, { count })
      : formatMessage({ defaultMessage: 'Notifiering' }));

  const classNameForMark = cn(
    count
      ? 'h-5 min-w-5 items-center justify-center px-1 text-sm text-contrast-red'
      : 'size-3',
    'flex rounded-full border-2 border-background-50 bg-red-500',
    className,
  );

  if (count != null) {
    return (
      <span role="status" aria-label={ariaLabel} className={classNameForMark}>
        <span aria-hidden="true">{count}</span>
      </span>
    );
  }

  return (
    <span className={classNameForMark}>
      <span className="sr-only">{ariaLabel}</span>
    </span>
  );
};
